import { render, staticRenderFns } from "./historyData.vue?vue&type=template&id=7002746d&scoped=true"
import script from "./historyData.vue?vue&type=script&lang=js"
export * from "./historyData.vue?vue&type=script&lang=js"
import style0 from "./historyData.vue?vue&type=style&index=0&id=7002746d&prod&lang=scss"
import style1 from "./historyData.vue?vue&type=style&index=1&id=7002746d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7002746d",
  null
  
)

export default component.exports